
let sliderThumbs;
let sliderImages;

function initializeSwipers() {
    const sliderThumbsEl = document.querySelector(".swiper-product-thumps");
    const sliderImagesEl = document.querySelector(".swiper-product");

    if (sliderThumbsEl && sliderImagesEl) {
        sliderThumbs = new Swiper(sliderThumbsEl, {
            slidesPerView: 5,
            centeredSlides: true,
            centeredSlidesBounds: true,
            spaceBetween: 8,
            freeMode: false,
            allowTouchMove: false,
            breakpoints: {
                740: {
                    slidesPerView: 5,
                },
                1000: {
                    slidesPerView: 7,
                }
            }
        });

        sliderImages = new Swiper(sliderImagesEl, {
            slidesPerView: 'auto',
            spaceBetween: 5,
            centeredSlides: true,
            centeredSlidesBounds: true,
            loop: false,
            thumbs: {
                swiper: sliderThumbs
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: false,
            }
        });

        function hasEnoughSlidesToSlide(swiper) {
            if (swiper.params.direction === 'vertical') {
                const slidesHeight = Array.from(swiper.slides).reduce((acc, slide) => acc + slide.offsetHeight + swiper.params.spaceBetween, 0);
                return slidesHeight > swiper.height;
            } else {
                const slidesWidth = Array.from(swiper.slides).reduce((acc, slide) => acc + slide.offsetWidth + swiper.params.spaceBetween, 0);
                return slidesWidth > swiper.width;
            }
        }

        sliderImages.on('slideChange', function () {
            const activeIndex = sliderImages.activeIndex;
            if (hasEnoughSlidesToSlide(sliderThumbs)) {
                sliderThumbs.slideTo(activeIndex);
            }
        });

        sliderThumbs.on('click', function (swiper) {
            const clickedIndex = swiper.clickedIndex;
            if (hasEnoughSlidesToSlide(sliderThumbs)) {
                sliderThumbs.slideTo(clickedIndex);
            }
            sliderImages.slideTo(clickedIndex);
        });

        function handleMouseMove(event) {
            const rect = sliderImagesEl.getBoundingClientRect();
            const x = event.clientX - rect.left;

            if (x < rect.width / 2) {
                sliderImagesEl.classList.add('left-side');
                sliderImagesEl.classList.remove('right-side');
            } else {
                sliderImagesEl.classList.add('right-side');
                sliderImagesEl.classList.remove('left-side');
            }
        }

        function handleMouseLeave() {
            sliderImagesEl.classList.remove('left-side');
            sliderImagesEl.classList.remove('right-side');
        }

        function handleClick(event) {
            const rect = sliderImagesEl.getBoundingClientRect();
            const x = event.clientX - rect.left;

            if (event.target.closest("video, .video-wrapper__poster-content")) {
                console.log("Video wurde geklickt, Slider bewegt sich nicht.");
                return;
            }

            if (x < rect.width / 2) {
                sliderImages.slidePrev();
            } else {
                sliderImages.slideNext();
            }
        }

        function stopVideosAndResetUI() {
            document.querySelectorAll("video").forEach(video => {
                if (!video.paused) {
                    video.pause();
                    console.log("Video gestoppt, weil Slider bewegt wurde.");

                    const videoContainer = video.closest(".video-container");
                    if (videoContainer) {
                        const playButton = videoContainer.querySelector(".video-wrapper__play-button");
                        if (playButton) playButton.style.display = "block";

                        const posterContent = videoContainer.querySelector(".video-wrapper__poster-content");
                        if (posterContent) posterContent.style.display = "flex";
                    }
                }
            });
        }

        sliderImages.on('slideChange', stopVideosAndResetUI);
        sliderThumbs.on('click', stopVideosAndResetUI);

        const prevButton = document.querySelector('.swiper-prev-button');
        const nextButton = document.querySelector('.swiper-next-button');

        if (prevButton && nextButton) {
            prevButton.addEventListener('click', stopVideosAndResetUI);
            nextButton.addEventListener('click', stopVideosAndResetUI);
        }

        function addEventListeners() {
            sliderImagesEl.addEventListener('mousemove', handleMouseMove);
            sliderImagesEl.addEventListener('mouseleave', handleMouseLeave);
            sliderImagesEl.addEventListener('click', handleClick);
        }

        function removeEventListeners() {
            sliderImagesEl.removeEventListener('mousemove', handleMouseMove);
            sliderImagesEl.removeEventListener('mouseleave', handleMouseLeave);
            sliderImagesEl.removeEventListener('click', handleClick);
        }

        if (window.innerWidth >= 1000) {
            addEventListeners();
        } else {
            removeEventListeners();
        }

        window.addEventListener('resize', function() {
            if (window.innerWidth >= 1000) {
                addEventListeners();
            } else {
                removeEventListeners();
            }
        });

        function updateSwipers() {
            sliderImages.update();
            sliderThumbs.update();
        }

        window.updateSwipers = updateSwipers;
    }
}


function initializeSliderButtons() {
    const prevButton = document.querySelector('.swiper-prev-button');
    const nextButton = document.querySelector('.swiper-next-button');

    if (prevButton && nextButton) {
        prevButton.addEventListener('click', () => {
            sliderImages.slidePrev();
        });

        nextButton.addEventListener('click', () => {
            sliderImages.slideNext();
        });
    }
}


function preloadCurrentAndNext() {
    if (!sliderImages || !sliderThumbs) return;
    
    const activeIndex = sliderImages.activeIndex;
    const slides = sliderImages.slides;
    const thumbSlides = sliderThumbs.slides;
    
    // Funktion um ein Bild auf eager zu setzen
    function setEager(slide, priority = 'auto') {
        const img = slide?.querySelector('img');
        if (img && img.getAttribute('loading') !== 'eager') {
            img.setAttribute('loading', 'eager');
            img.setAttribute('fetchpriority', priority);
        }
    }
    
    // Aktuelles Bild (falls nicht schon eager)
    setEager(slides[activeIndex], 'high');
    
    // Nächstes und vorheriges Bild (für Swipe-Performance)
    if (slides[activeIndex + 1]) setEager(slides[activeIndex + 1]);
    if (slides[activeIndex - 1]) setEager(slides[activeIndex - 1]);
    
    // Noch 2 weitere in Swipe-Richtung
    if (slides[activeIndex + 2]) setEager(slides[activeIndex + 2]);
    if (slides[activeIndex + 3]) setEager(slides[activeIndex + 3]);
    
    // Thumbnails: Aktueller + ein paar drumherum
    for (let i = -2; i <= 5; i++) {
        const thumbIndex = activeIndex + i;
        if (thumbIndex >= 0 && thumbIndex < thumbSlides.length) {
            const thumbImg = thumbSlides[thumbIndex]?.querySelector('img');
            if (thumbImg && thumbImg.getAttribute('loading') !== 'eager') {
                thumbImg.setAttribute('loading', 'eager');
                thumbImg.setAttribute('fetchpriority', 'auto');
            }
        }
    }
}

// Hilfsfunktion für die komplette Initialisierung
function initializeSliders() {
    initializeSwipers();
    initializeSliderButtons();
    
    if (sliderImages) {
        // Initial preloading
        preloadCurrentAndNext();
        
        // Bei Slide-Wechsel
        sliderImages.on('slideChange', preloadCurrentAndNext);
        sliderThumbs.on('click', preloadCurrentAndNext);
    }
}

document.addEventListener('DOMContentLoaded', initializeSliders);


var isProcessing = false;

async function removeProductFromCart() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    const productInCart = cart.items.find(item => item.variant_id == window.variant_id);
    
    if (productInCart) {
      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: 'id=' + window.variant_id + '&quantity=0'
      });
      
      if (!removeResponse.ok) {
        console.error("Fehler beim Entfernen des Produkts aus dem Warenkorb.");
      }
    }
  } catch (error) {
    console.error("Fehler beim Warenkorb-Management:", error);
  }
}

function initialize() {
  removeProductFromCart();
  observeToggleButton();
}

function observeToggleButton() {
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        var checkbox = document.querySelector('#shipping-switch-new');
        if (checkbox) {
          var checkoutButton = document.querySelector('#checkout-button');
          if (checkoutButton) {
            checkoutButton.addEventListener('click', function() {
              handleCheckoutClick(checkoutButton);
            });
          }
          observer.disconnect();
        }
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function handleCheckoutClick(element) {
  if (isProcessing) {
    return;
  }
  
  var checkoutButton = document.querySelector('#CartDrawer-Checkout');
  checkoutButton.classList.add('loading');
  var spinner = checkoutButton.querySelector('.loading__spinner');
  if (spinner) {
    spinner.classList.remove('hidden');
  }
  var checkbox = document.querySelector('#shipping-switch-new');
  
  if (checkbox && checkbox.checked) {
    isProcessing = true;
    addProductToCart(function() {
      document.querySelector('#CartDrawer-Checkout').click();
    });
  } else {
    document.querySelector('#CartDrawer-Checkout').click();
  }
}

function addProductToCart(callback) {
  var formData = new FormData(document.querySelector('form.priority-processing'));
  formData.append('id', window.variant_id);
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js', true);
  xhr.send(formData);
  xhr.onload = function() {
    var checkoutButton = document.querySelector('#CartDrawer-Checkout');
    if (xhr.status === 200) {
      if (callback) {
        callback();
      }
      checkoutButton.classList.remove('loading');
      var spinner = checkoutButton.querySelector('.loading__spinner');
      if (spinner) {
        spinner.classList.add('hidden');
      }
    } else {
      console.error("Fehler beim Hinzufügen des Produkts zum Warenkorb.");
      isProcessing = false;
      checkoutButton.classList.remove('loading');
      var spinner = checkoutButton.querySelector('.loading__spinner');
      if (spinner) {
        spinner.classList.add('hidden');
      }
    }
  };
}

window.addEventListener('pageshow', function(event) {
  initialize();
});


function setHeaderHeight() {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper) {
    const headerHeight = headerWrapper.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }
}

document.addEventListener('DOMContentLoaded', setHeaderHeight);
window.addEventListener('resize', setHeaderHeight);


document.addEventListener('DOMContentLoaded', function() {
  var faqDetails = document.querySelectorAll('faq');
  
  faqDetails.forEach(function(details) {
    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    var isAnimating = false;
    
    if (details.hasAttribute('open')) {
      summary.setAttribute('aria-expanded', 'true');
      content.style.height = content.scrollHeight + "px";
    } else {
      summary.setAttribute('aria-expanded', 'false');
      content.style.height = "0";
    }
    
    summary.addEventListener('click', function(event) {
      event.preventDefault();
      
      if (isAnimating) return;
      
      isAnimating = true;
      
      var isExpanded = details.hasAttribute('open');
      summary.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      
      if (isExpanded) {
        content.style.height = content.scrollHeight + "px";
        
        requestAnimationFrame(function() {
          content.style.height = "0";
          
          content.addEventListener('transitionend', function handler() {
            details.removeAttribute('open');
            content.removeEventListener('transitionend', handler);
            isAnimating = false;
          }, { once: true });
        });
      } else {
        details.setAttribute('open', 'true');
        
        var height = content.scrollHeight;
        content.style.height = "0";
        
        requestAnimationFrame(function() {
          content.style.height = height + "px";
          
          content.addEventListener('transitionend', function handler() {
            content.style.height = "auto";
            content.removeEventListener('transitionend', handler);
            isAnimating = false;
          }, { once: true });
        });
      }
    });
    
    content.addEventListener('transitioncancel', function() {
      isAnimating = false;
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const scrollButtons = document.querySelectorAll('.scroll-to-btn');
  
  function calculateOffset() {
    const rootStyles = getComputedStyle(document.documentElement);
    let totalOffset = 0;
    
    const headerHeight = rootStyles.getPropertyValue('--header-height').trim();
    if (headerHeight) {
      totalOffset += parseInt(headerHeight);
    }
    
    const announcementBarHeight = rootStyles.getPropertyValue('--announcement-bar-height').trim();
    if (announcementBarHeight) {
      totalOffset += parseInt(announcementBarHeight);
    }
    
    return totalOffset;
  }
  
  scrollButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const target = this.getAttribute('data-scroll-target');
      if (!target) return;
      
      let targetElement;
      
      if (target.startsWith('#')) {
        targetElement = document.querySelector(target);
      } else if (target.startsWith('.')) {
        targetElement = document.querySelector(target);
      } else {
        targetElement = document.querySelector('.' + target);
      }
      
      if (targetElement) {
        const offset = calculateOffset();
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth'
        });
      } else {
        console.warn('Scroll-to Ziel nicht gefunden:', target);
      }
    });
  });
});


class JudgeMeBadgeInjector {
    constructor() {
        this.init();
    }

    init() {
        this.addBadgesToExistingReviews();
        this.observeNewReviews();
    }

    addBadgesToExistingReviews() {
        const authorWrappers = document.querySelectorAll('.jdgm-rev__author-wrapper');
        let addedCount = 0;

        authorWrappers.forEach(wrapper => {
            if (this.addBadgeToWrapper(wrapper)) {
                addedCount++;
            }
        });
    }

    addBadgeToWrapper(wrapper) {
        const existingBadge = wrapper.querySelector('.jdgm-rev__buyer-badge-wrapper');
        if (existingBadge) {
            return false;
        }

        const badgeHTML = `
            <span class="jdgm-rev__buyer-badge-wrapper">
                <span class="jdgm-rev__buyer-badge"></span>
            </span>
        `;

        const authorSpan = wrapper.querySelector('.jdgm-rev__author');
        if (authorSpan) {
            authorSpan.insertAdjacentHTML('afterend', badgeHTML);
            return true;
        }

        return false;
    }

    observeNewReviews() {
        const reviewContainer = document.querySelector('.jdgm-rev-widg__reviews');
        if (!reviewContainer) {
            return;
        }

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1 && node.classList && node.classList.contains('jdgm-rev')) {
                        const authorWrapper = node.querySelector('.jdgm-rev__author-wrapper');
                        if (authorWrapper) {
                            this.addBadgeToWrapper(authorWrapper);
                        }
                    }
                });
            });
        });

        observer.observe(reviewContainer, {
            childList: true,
            subtree: true
        });
    }

    removeAllBadges() {
        const badges = document.querySelectorAll('.jdgm-rev__buyer-badge-wrapper');
        badges.forEach(badge => badge.remove());
    }

    addBadgeToSpecificAuthors(authorNames) {
        const authorWrappers = document.querySelectorAll('.jdgm-rev__author-wrapper');
        let addedCount = 0;

        authorWrappers.forEach(wrapper => {
            const authorSpan = wrapper.querySelector('.jdgm-rev__author');
            if (authorSpan && authorNames.includes(authorSpan.textContent.trim())) {
                if (this.addBadgeToWrapper(wrapper)) {
                    addedCount++;
                }
            }
        });
    }

    setVerifiedBuyerAttribute() {
        const reviews = document.querySelectorAll('.jdgm-rev');
        reviews.forEach(review => {
            review.setAttribute('data-verified-buyer', 'true');
        });
    }
}

const badgeInjector = new JudgeMeBadgeInjector();

window.addVerifiedBadges = () => badgeInjector.addBadgesToExistingReviews();
window.removeAllBadges = () => badgeInjector.removeAllBadges();
window.setVerifiedBuyer = () => badgeInjector.setVerifiedBuyerAttribute();
window.addBadgeToSpecific = (authors) => badgeInjector.addBadgeToSpecificAuthors(authors);


document.addEventListener('DOMContentLoaded', function() {
  
  function showSpinner(button) {
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) {
      button.classList.add('loading');
      spinner.classList.remove('hidden');
      button.setAttribute('aria-disabled', 'true');
      
      setTimeout(() => {
        button.classList.remove('loading');
        spinner.classList.add('hidden');
        button.removeAttribute('aria-disabled');
      }, 1000);
    }
  }

  document.addEventListener('click', function(e) {
    
    if (e.target.matches('button[type="submit"][name="checkout"]') || e.target.closest('button[type="submit"][name="checkout"]')) {
      const button = e.target.matches('button[type="submit"][name="checkout"]') ? e.target : e.target.closest('button[type="submit"][name="checkout"]');
      if (!button.classList.contains('loading')) {
        showSpinner(button);
      }
    }
    
    if (e.target.matches('.over-button') || e.target.closest('.over-button')) {
      const overButton = e.target.matches('.over-button') ? e.target : e.target.closest('.over-button');
      const submitButton = overButton.parentElement.querySelector('button[type="submit"]');
      if (submitButton && !submitButton.classList.contains('loading')) {
        showSpinner(submitButton);
      }
    }
  });
  
});